module.exports = __webpack_public_path__ + "img/xianmi2_5kg.e73aca8a.jpg";